import Box from '@/Atoms/Box';
import CCButton from '@/Atoms/CCButton';
import CCText from '@/Atoms/CCText';
import CCColors from '@/Utils/CCColors';
import {FontSizes} from '@/Utils/Dimensions';
import {MaterialCommunityIcons} from '@expo/vector-icons';
import {StyleSheet} from 'react-native';

interface BannerProps {
  backgroundColor: string;
  iconName: string;
  iconColor?: string;
  titleText: string;
  subtitleText?: string;
  ctaText?: string;
  onClose: () => void;
  handlePress: () => void;
  closeIcon?: boolean;
  borderColor?: string;
  highlight?: number;
  textColor?: '';
}

const MeetingsBanner: React.FC<BannerProps> = ({
  backgroundColor,
  iconName,
  iconColor,
  titleText,
  subtitleText = 'Get 20% off—upgrade your plan today',
  ctaText = 'View Plans',
  onClose,
  handlePress,
  closeIcon,
  borderColor,
  highlight,
  textColor,
}) => {
  return (
    <Box
      flexDirection="row"
      alignItems="center"
      justifyContent="space-between"
      style={styles.container}>
      <Box flexDirection="row" style={styles.text} alignItems="center">
        <Box
          alignItems="center"
          justifyContent="center"
          style={[
            styles.iconWrapper,
            {backgroundColor: backgroundColor, borderColor: borderColor},
          ]}>
          <MaterialCommunityIcons name={iconName} size={13} color={iconColor} />
        </Box>

        <CCText
          fontWeight={600}
          color={textColor}
          fontSize={FontSizes[13]}
          style={styles.titleText}>
          {titleText}
        </CCText>
        {subtitleText && (
          <CCText
            fontWeight={400}
            fontSize={FontSizes[10]}
            style={styles.subtitleText}>
            {subtitleText}
          </CCText>
        )}
      </Box>
      <Box
        flexDirection="row"
        alignItems="center"
        gap={10}
        style={styles.rtbox}>
        <CCButton
          contentContainerStyle={styles.ctaButtonContent}
          onPress={handlePress}
          style={[
            styles.ctaButton,
            {
              backgroundColor: highlight
                ? CCColors.Primary.Default
                : CCColors.CCTableBg,
            },
          ]}>
          <CCText fontWeight={500} fontSize={FontSizes[13]}>
            {ctaText}
          </CCText>
        </CCButton>
        {closeIcon && (
          <Box
            onPress={onClose}
            alignItems="center"
            justifyContent="center"
            style={styles.closeButton}>
            <MaterialCommunityIcons name="close" size={14} />
          </Box>
        )}
      </Box>
    </Box>
  );
};

const styles = StyleSheet.create({
  container: {
    width: '100%',
    paddingRight: 5,
  },
  iconWrapper: {
    width: 25,
    height: 25,
    borderRadius: 14,
    alignItems: 'center',
    justifyContent: 'center',
    borderWidth: 1,
  },
  titleText: {
    paddingHorizontal: 20,
  },
  subtitleText: {
    paddingHorizontal: 5,
  },
  ctaButtonContent: {
    paddingHorizontal: 12,
    paddingVertical: 5,
  },
  ctaButton: {
    marginHorizontal: 8,
  },
  closeButton: {
    width: 25,
    height: 25,
    borderRadius: 14,
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: CCColors.CCTableBg,
  },
  rtbox: {
    marginRight: 5,
  },
  text: {
    maxWidth: '90%',
  },
});

export default MeetingsBanner;
